/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as CodeDefault } from './code-default.story';
export { default as CodeWithActions } from './code-with-actions.story';
export { default as CodeWithHeader } from './code-with-header.story';
export { default as CodeOverflow } from './code-overflow.story';
export { default as CodeDisabled } from './code-disabled.story';
export { default as CodeLineNumbers } from './code-with-line-numbers.story';
export { default as CodeLanguages } from './code-languages.story';
export { default as CodeFull } from './code-full.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import CodeDefaultSrcRaw from './code-default.story?raw';
import CodeDisabledSrcRaw from './code-disabled.story?raw';
import CodeFullSrcRaw from './code-full.story?raw';
import CodeLanguagesSrcRaw from './code-languages.story?raw';
import CodeOverflowSrcRaw from './code-overflow.story?raw';
import CodeWithActionsSrcRaw from './code-with-actions.story?raw';
import CodeWithHeaderSrcRaw from './code-with-header.story?raw';
import CodeLineNumbersSrcRaw from './code-with-line-numbers.story?raw';

export const CodeDefaultSrc = removeLicenseHeader(CodeDefaultSrcRaw);

export const CodeWithActionsSrc = removeLicenseHeader(CodeWithActionsSrcRaw);
export const CodeWithHeaderSrc = removeLicenseHeader(CodeWithHeaderSrcRaw);
export const CodeOverflowSrc = removeLicenseHeader(CodeOverflowSrcRaw);
export const CodeDisabledSrc = removeLicenseHeader(CodeDisabledSrcRaw);
export const CodeLineNumbersSrc = removeLicenseHeader(CodeLineNumbersSrcRaw);
export const CodeLanguagesSrc = removeLicenseHeader(CodeLanguagesSrcRaw);
export const CodeFullSrc = removeLicenseHeader(CodeFullSrcRaw);
